import { mapState, mapGetters } from 'vuex'
import i18n from '@vue-storefront/i18n'
import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'
import RootState from '@vue-storefront/core/types/RootState'
import { Logger } from '@vue-storefront/core/lib/logger'
import { searchProducts } from '@vue-storefront/core/lib/catalogSearch'

export const Search = {
  name: 'SearchPanel',
  data () {
    return {
      products: [],
      search: '',
      size: 12,
      start: 0,
      placeholder: i18n.t('Type what you are looking for...'),
      emptyResults: false,
      readMore: true,
      total: 0,
      sort:'',
      noResults: false,
      preloader: true
    }
  },
  mounted () {
    //
  },
  beforeDestroy () {
    localStorage.setItem(`shop/user/searchQuery`, this.search ? this.search : '');
  },
  methods: {
    onEscapePress () {
      this.closeSearchpanel()
    },
    closeSearchpanel () {
      this.$store.commit('ui/setSidebar', false)
      this.$store.commit('ui/setMicrocart', false)
      this.$store.commit('ui/setSearchpanel', false)
    },
    makeSearch () {
      if (this.search !== '' && this.search !== undefined) {
        if (this.$route.name === 'search' && this.$route.query.search !== this.search) {
          this.processPartnerSearch(this.search)
        }
        let startValue = 0;
        this.start = startValue
        this.readMore = true
        this.$store.dispatch('product/list', {
          semanticFetch: () => searchProducts({ text: this.search, start: this.start, size: this.size }),
          updateState: false
        }).then(resp => {
          this.products = resp.items
          this.total = resp.total
          this.start = startValue + this.size
          this.emptyResults = resp.items.length < 1
          this.noResults = !this.products.length
        }).catch((err) => {
          Logger.error(err, 'components-search')()
        })
          .finally(() => {
            this.preloader = false
          })
      } else {
        this.products = []
        this.emptyResults = 0
        this.preloader = false
      }
    },
    onSortOrderChanged (sort) {
      this.start = 0
      this.$store.dispatch('product/list', {
        semanticFetch: () => searchProducts({ text: this.search, start: this.start, size: this.size, sort: sort.attribute }),
        updateState: false
      }).then(resp => {
        this.products = resp.items
        this.total = resp.total
        this.sort = sort.attribute
        this.start += this.size
        this.emptyResults = resp.items.length < 1
      }).catch((err) => {
        Logger.error(err, 'components-search')()
      })
    },
    seeMore () {
      if (this.search !== '' && this.search !== undefined) {
        let startValue = this.start;
        this.$store.dispatch('product/list', {
          semanticFetch: () => searchProducts({ text: this.search, start: startValue, size: this.size, sort: this.sort }),
          updateState: false
        }).then((resp) => {
          let page = Math.floor(resp.total / this.size)
          let exceeed = resp.total - this.size * page
          if (resp.start === resp.total - exceeed) {
            this.readMore = false
          }
          this.products = this.products.concat(resp.items)
          this.start = startValue + this.size
          this.emptyResults = this.products.length < 1
        }).catch((err) => {
          Logger.error(err, 'components-search')()
        })
      } else {
        this.products = []
        this.emptyResults = 0
      }
    },
    processPartnerSearch (query) {
      this.$router.push({ path: `${this.currentPartner.route}/search`, query: { search: query } })
    }
  },
  computed: {
    items () {
      return this.$store.state.search
    },
    ...mapState({
      isOpen: (state: RootState) => state.ui.searchpanel
    }),
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
  },
  mixins: [onEscapePress]
}
